<template>
    <div class="messaging error simple" v-if="errors[prop]">
        <p v-for="error in errors[prop]" v-text="error"></p>
    </div>
</template>
<script>
export default {
    props: ['errors', 'prop']
}
</script>
